import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

import { MessageFacade } from './message.facade';
import { ConversationModel } from './message.models';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  providers: [MessageFacade],
})
export class MessageComponent implements OnChanges {
  @Input() loading = false;
  @Input() updating = false;
  @Input() emptyMessage = 'Aucune conversation ...';
  @Input() displayMarkAsReadButton = true;
  @Input() conversations: ConversationModel[];
  @Input() origin = 'list';
  @Output() refresh = new EventEmitter<void>();

  public isLoadingMessages = false;
  public error?: string;
  public selectedConversation?: ConversationModel;

  constructor(private facade: MessageFacade) {
    // nothing
  }

  ngOnChanges(): void {
    if (this.conversations?.length > 0 && !this.selectedConversation) {
      this.openConversation(this.conversations[0]);
    } else {
      this.selectedConversation = undefined;
    }
  }

  loadConversations() {
    this.refresh?.emit();
  }

  async markMessagesAsRead() {
    this.updating = true;

    await this.facade.markDietitianConversationsAsRead();
    this.loadConversations();

    this.updating = false;
  }

  openConversation(conversation: ConversationModel) {
    this.selectedConversation = conversation;
  }

  messageBack() {
    if (this.conversations.length > 0) {
      for (let i = 0; i < this.conversations.length; i++) {
        if (this.conversations[i] === this.selectedConversation) {
          this.selectedConversation =
            i + 1 < this.conversations.length
              ? this.conversations[i + 1]
              : this.conversations[i];
          break;
        }
      }
    }
  }

  messageForward() {
    if (this.conversations.length > 0) {
      for (let i = this.conversations.length - 1; i >= 0; i--) {
        if (this.conversations[i] === this.selectedConversation) {
          this.selectedConversation =
            i - 1 >= 0 ? this.conversations[i - 1] : this.conversations[i];
          break;
        }
      }
    }
  }
}
